import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NetworkManager from "../../app/managers/networkManager";
import { config } from "../../app/utils/config";
import { store } from "../../app/store/store";
import { setIsLoading } from "../common/commonSlice";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import { Localize } from "../../app/lang/langs";


export const statusOptions = [
    { label: Localize("Upcoming"), value: "upcoming", color: " #3c1053" },
    { label: Localize("Awaiting completion"), value: "awaiting_completion", color: "#f2a900" },
    { label: Localize("Awaiting scheduling"), value: "awaiting_scheduling", color: "#005670" },
    { label: Localize("Ongoing"), value: "ongoing", color: "#041e42" },
    { label: Localize("Done"), value: "done", color: "#4c8c2b" }
]

export const InterviewsTypesOptions = [
    { label: "2 ans", value: "2" },
    { label: "3 ans", value: "3" },
    { label: "6 ans", value: "6" }
]

const initialState = {
    userDetails: null,
    clients: null,
    postes: null,
    selectedEntretien: null,
    interviewsList: null,
}

export const VentrSlice = createSlice({
    name: "ventr",
    initialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.userDetails = action.payload;
        },
        setClients: (state, action) => {
            state.clients = action.payload;
        },
        setPostes: (state, action) => {
            state.postes = action.payload;
        },
        setSelectedEntretien: (state, action) => {
            state.selectedEntretien = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getClients.fulfilled, (state, action) => {
            if (action.payload.responseData) {
                state.clients = action.payload.responseData
            }
        });
        builder.addCase(getInterviews.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.interviewsList = action.payload.responseData.data
            }
        });
        builder.addCase(insertInterview.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast("Interview insérée avec succès")
            } else {
                showErrorToast("Impossible d'insérer l'interview")
            }
        });
        builder.addCase(updateInterview.fulfilled, (state, action) => {

        });
        // builder.addCase(getPostes.fulfilled, (state, action) => {
        //     state.postes = action.payload.responseData;
        // });
    },
});


export const getClients = createAsyncThunk(
    "ventr/getClients",
    async () => {
        try {
            let response = await NetworkManager.getInstance().getRequest(
                config.apiPaths.planning.getClients
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);


export const getInterviews = createAsyncThunk(
    "ventr/getInterviews",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.ventr.getInterviews,
                body
            );
            return response
        } catch (error) {
            showErrorToast("Couldn't get the data");
            return error;
        }
    }
)
export const insertInterview = createAsyncThunk(
    "ventr/insertInterview",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.ventr.insertInterview,
                body
            );
            return response
        } catch (error) {
            showErrorToast("Couldn't get the data");
            return error;
        }
    }
)
export const updateInterview = createAsyncThunk(
    "ventr/updateInterview",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.ventr.updateInterview,
                body
            );
            return response
        } catch (error) {
            showErrorToast("Couldn't get the data");
            return error;
        }
    }
)
export const generateInterviewPDF = createAsyncThunk(
    "ventr/generateInterviewPDF",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().fetchFile(
                config.apiPaths.ventr.generateInterviewPDF,
                body,
                body["fileName"] || "interview.pdf"
            );
            return response
        } catch (error) {
            showErrorToast("Couldn't get the data");
            return error;
        }
    }
)

export const { setSelectedView, setSelectedEntretien, setInterviewData } = VentrSlice.actions;



export default VentrSlice.reducer;